import React from "react";
import {
  buildSchedulerStylesheet,
  resolveSchedulerClasses,
} from "./ElementSchedulerStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";
import {
  listedSchedulerType,
  schedulerTypeLabel,
  schedulerTypeMeta,
} from "../../utils/schedulerTypes";

const ElementScheduler = (props) => {
  let element = props.element;
  const classes = resolveSchedulerClasses(element);
  const stylesheet = buildSchedulerStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    props.variant
  );
  const schedulerType = listedSchedulerType(
    element.options["scheduler_type"] || "calendly"
  );
  const schedulerMeta = schedulerTypeMeta(schedulerType);
  const schedulerUrl = element.options["scheduler-url"]
    ? element.options["scheduler-url"]
    : "";

  return (
    <React.Fragment>
      <div className={classes}>
        <div
          className="cf-scheduler"
          data-scheduler-type={schedulerType}
          data-scheduler-url={schedulerUrl}
        >
          {props.builder == true && (
            <div className="cf-html-placeholder element-content">
              <img
                className="cf-scheduler-placeholder-icon"
                src={schedulerMeta.icon}
                alt=""
              />
              <div>
                <strong>
                  Scheduler:{" "}
                  <em>
                    {schedulerUrl
                      ? `${schedulerTypeLabel(schedulerType)} — ${schedulerUrl}`
                      : `${schedulerTypeLabel(schedulerType)} embed`}
                  </em>
                </strong>
                <br></br>
                Click to edit
              </div>
            </div>
          )}
        </div>
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:scheduler`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

export default ElementScheduler;
